/* eslint-disable jsx-a11y/prefer-tag-over-role */
// * TertiaryGrid Component
// * Renders the third and deepest level of the grid.
import React from 'react';
import { InfoIcon } from './InfoIcon';

export const TertiaryGrid = ({ headers, rows, onOpenModal }) => {
  const totalColumns = Math.max(
    headers.reduce((count, header) => {
      return count + (header.subheaders ? header.subheaders.length : 1);
    }, 0),
    1
  );

  const PAST_DUE_MESSAGE = "A sample from this group was missed during a previous compliance cycle. To be current with monitoring requirements, the water system must collect the required number of sample(s) during the period shown in the ‘Next Sample Due’ field and submit the results to DDW.";
  const REPEAT_SAMPLE_MESSAGE = "For repeat samples, sample upstream, downstream, and at the original site.";

  const gridStyle = {
    gap: '0rem',
    backgroundColor: '#fff',
    border: '1px solid #f3f4f6',
    borderRadius: '0.375rem',
  };

  const rowGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${totalColumns}, 1fr)`
  };

  const hasHeaders = headers && headers.length > 0;
  const hasRows = rows && rows.length > 0;
  return (
    <div style={gridStyle} role="grid" aria-label="Tertiary monitoring data">
      {hasHeaders ? (
        <div role="row" style={rowGridStyle}>
          {headers.map((header) => {
            if (typeof header === 'string') {
              return (
                <div key={header} className="grid-header-tertiary single" style={{ gridRow: '1 / 3'}} role="columnheader">
                  {header}
                </div>
              );
            } else {
              return (
                <React.Fragment key={header.title}>
                  <div className="grid-header-tertiary split-main-title-tertiary" style={{ gridColumn: `span ${header.subheaders.length}` }} role="columnheader">
                    {header.title}
                  </div>
                  {header.subheaders.map((subheader) => (
                    <div key={subheader} className="grid-header-tertiary split-subheader-tertiary" role="columnheader">
                      {subheader}
                    </div>
                  ))}
                </React.Fragment>
              );
            }
          })}
        </div>
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="columnheader" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data</div>
        </div>
      )}

      {hasRows ? (
        rows.map((row, index) => (
          <div key={row.id} role="row" style={rowGridStyle}>
            {row.cells.map((cell, cellIndex) => (
              <div key={cellIndex} className={`grid-cell-tertiary ${index % 2 === 0 ? 'is-even' : 'is-odd'}`} role="gridcell">
                {cell}
                {cell === 'Past Due' && (<button onClick={(e) => onOpenModal(e, "Past Due Sample", PAST_DUE_MESSAGE)} className="info-icon-button" aria-label="Past Due Sample information"><InfoIcon /></button>)}
                {(cell === 'RP' || cell === 'Repeat') && <button onClick={(e) => onOpenModal(e, "Repeat Sample Information", REPEAT_SAMPLE_MESSAGE)} className="info-icon-button" aria-label="Repeat Sample information"><InfoIcon /></button>}
              </div>
            ))}
          </div>
        ))
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="gridcell" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data available</div>
        </div>
      )}
    </div>
  );
};
